import React, { useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const ControlArea = ({
  btnTxt = false,
  cardTxt,
  icon,
  url,
  handleClick = false,
}) => {
  useEffect(() => {
    const buttons = document.querySelectorAll('[data-animation="ripple"]');

    [...buttons].forEach((button) => {
      button.onmousedown = function (e) {
        const x = e.pageX - this.offsetLeft;
        const y = e.pageY - this.offsetTop;
        const w = this.offsetWidth;

        const ripple = document.createElement("span");

        ripple.className = "ripple";
        ripple.style.left = x + "px";
        ripple.style.top = y + "px";
        ripple.style.setProperty("--scale", w);

        this.appendChild(ripple);

        setTimeout(() => {
          ripple.parentNode.removeChild(ripple);
        }, 500);
      };
    });
  }, []);

  return (
    <>
      <div className="control-wrp">
        <Row className="row-gap-2">
          {btnTxt && (
            <Col xl={4} md={4} sm={12}>
              <NavLink
                to={url}
                onClick={(e) => {
                  if (handleClick !== false) {
                    e.preventDefault();
                    handleClick();
                  }
                }}
                className="btn btn-big btn-blue"
                data-animation="ripple"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14.4286 6.39286H9.60714V1.57143C9.60714 0.979799 9.12734 0.5 8.53571 0.5H7.46429C6.87266 0.5 6.39286 0.979799 6.39286 1.57143V6.39286H1.57143C0.979799 6.39286 0.5 6.87266 0.5 7.46429V8.53571C0.5 9.12734 0.979799 9.60714 1.57143 9.60714H6.39286V14.4286C6.39286 15.0202 6.87266 15.5 7.46429 15.5H8.53571C9.12734 15.5 9.60714 15.0202 9.60714 14.4286V9.60714H14.4286C15.0202 9.60714 15.5 9.12734 15.5 8.53571V7.46429C15.5 6.87266 15.0202 6.39286 14.4286 6.39286Z"
                    fill="white"
                  />
                </svg>
                {btnTxt}
              </NavLink>
            </Col>
          )}
          <Col>
            <div className="card">
              <h5>
                <img src={icon} width={20} height={20} alt="" />
                {cardTxt}
              </h5>
            </div>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default ControlArea;

// {
//   "_id": {
//     "$oid": "65f2e875a8d5122d38d96b29"
//   },
//   "title": "terms-and-conditions",
//   "slug": "privacy-terms",
//   "content": {
//     "section0": {
//       "title": " ",
//       "id": 0,
//       "description": {
//         "en": "<h3 class=\"ql-align-right\">ما هي سياسة الخصوصية؟</h3><p class=\"ql-align-right\"><br></p><p class=\"ql-align-right\">سياسة الخصوصية هي وثيقة قانونية تكشف فيها عن البيانات التي تجمعها من المستخدمين، وكيفية إدارتك للبيانات المجمعة وكيفية استخدامك لهذه البيانات. الهدف المهم لسياسة الخصوصية هو إعلام المستخدمين بكيفية جمع واستخدام وإدارة ما تم جمعه.</p><h3 class=\"ql-align-right\">هل منشئ سياسة الخصوصية مجاني للاستخدام؟</h3><p class=\"ql-align-right\"><br></p><p class=\"ql-align-right\">يعد منشئ سياسة الخصوصية (Privacypolicygenerator.Info) منشئًا مجانيًا لسياسات الخصوصية لمواقع الويب والتطبيقات وصفحات/تطبيق Facebook. يمكنك استخدام المولد المجاني الخاص بنا لإنشاء سياسة الخصوصية لعملك.</p><h3 class=\"ql-align-right\">لماذا تعتبر سياسة الخصوصية مهمة؟</h3><p class=\"ql-align-right\"><br></p><p class=\"ql-align-right\">أهم شيء يجب أن تتذكره هو أن سياسة الخصوصية مطلوبة بموجب القانون إذا قمت بجمع البيانات من المستخدمين، سواء بشكل مباشر أو غير مباشر. على سبيل المثال، إذا كان لديك نموذج اتصال على موقع الويب الخاص بك، فأنت بحاجة إلى سياسة خصوصية. ولكنك ستحتاج أيضًا إلى سياسة خصوصية إذا كنت تستخدم أدوات التحليل مثل Google Analytics.</p><h3 class=\"ql-align-right\">أين أضع سياسة الخصوصية الخاصة بي؟</h3><p class=\"ql-align-right\"><br></p><p class=\"ql-align-right\">عادةً، يمكنك العثور على سياسات الخصوصية في تذييل موقع الويب. نوصي بوضع سياسة الخصوصية الخاصة بك في مواقع يسهل العثور عليها على موقع الويب الخاص بك.</p><h3 class=\"ql-align-right\">ما الذي يجب أن تتضمنه سياسة الخصوصية؟</h3><p class=\"ql-align-right\"><br></p><p class=\"ql-align-right\">يجب أن تتضمن سياسة الخصوصية القياسية ما يلي: ما هي البيانات التي تجمعها من الزوار، وكيف تجمعها، ولماذا تجمع البيانات، وكيف تستخدم البيانات.</p><h3 class=\"ql-align-right\">هل يمكنني نسخ سياسة الخصوصية لشخص آخر؟</h3><p class=\"ql-align-right\"><br></p><p class=\"ql-align-right\">لا نوصي بنسخ سياسة الخصوصية الخاصة بشخص آخر. أولاً وقبل كل شيء، سياسات الخصوصية هي وثائق قانونية محمية بحقوق الطبع والنشر. ولكن الأهم من ذلك هو أنه يجب إنشاء سياسة خصوصية بناءً على البيانات الدقيقة التي تجمعها. يمكن لمنشئ سياسة الخصوصية لدينا مساعدتك في ذلك.</p>",
//         "ar": "<p>sdasda</p>"
//       }
//     }
//   },
//   "createdAt": {
//     "$date": {
//       "$numberLong": "1710418037134"
//     }
//   },
//   "updatedAt": {
//     "$date": {
//       "$numberLong": "1710983408408"
//     }
//   },
//   "__v": 0
// }
